export const getAllShops = async (): Promise<any[]> => {
  const response = await fetch("/api/v1/shops?limit=500", {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!response.ok) throw new Error("Failed to get all shops");
  const result = await response.json();
  const items = result?.data?.items;
  return Array.isArray(items) ? items : [];
};

export const getShopById = async (name: string): Promise<any> => {
  const response = await fetch(
    `/api/v1/shops/detail?name=${encodeURIComponent(name)}`,
    {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }
  );
  if (!response.ok) throw new Error("Failed to get shop by id");
  const result = await response.json();
  return result?.data?.item ?? result?.data ?? result;
};

export const createShop = async (shop: any): Promise<any> => {
  const response = await fetch("/api/v1/shops", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(shop),
  });
  if (!response.ok) throw new Error("Failed to create shop");
  const result = await response.json();
  return result?.data?.item ?? result?.data ?? result;
};

export const updateShop = async (name: string, shop: any): Promise<any> => {
  const response = await fetch("/api/v1/shops/update", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, ...shop }),
  });
  if (!response.ok) throw new Error("Failed to update shop");
  const result = await response.json();
  return result?.data?.item ?? result?.data ?? result;
};

export const deleteShop = async (name: string): Promise<any> => {
  const response = await fetch("/api/v1/shops/delete", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name }),
  });
  if (!response.ok) throw new Error("Failed to delete shop");
  const result = await response.json();
  return result?.data ?? result;
};
